<template>
  <div class="checkbox-wrapper" :class="{ 'checkbox-wrapper-disabled': disabled }" @click="handleClick">
    <div class="checkbox-box" v-bind:class="getCheckboxStyle()">
      <i v-if="checkState === checkStatusEnums.CHECKED" class="bx bx-check" />
      <i v-if="checkState === checkStatusEnums.CHECKED_SOME" class="bx bx-minus" />
    </div>
    <slot></slot>
  </div>
</template>
<script>
import CHECK_STATUS_ENUM from '../../CheckboxStateEnum.json';

export default {
  name: 'LineBroadcastCheckbox',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    checkState: {
      type: String,
      default: CHECK_STATUS_ENUM.UNCHECK,
      validator(val) {
        return Object.values(CHECK_STATUS_ENUM).includes(val);
      },
    },
  },
  data() {
    return {
      checkStatusEnums: CHECK_STATUS_ENUM,
    };
  },
  methods: {
    getCheckboxStyle() {
      return {
        'checkbox-box--uncheck': this.checkState === this.checkStatusEnums.UNCHECK,
        'checkbox-box--uncheck-disabled': this.checkState === this.checkStatusEnums.UNCHECK && this.disabled,
        'checkbox-box--checked': this.checkState === this.checkStatusEnums.CHECKED,
        'checkbox-box--checked-disabled': this.checkState === this.checkStatusEnums.CHECKED && this.disabled,
        'checkbox-box--checked-some': this.checkState === this.checkStatusEnums.CHECKED_SOME,
        'checkbox-box--checked-some-disabled': this.checkState === this.checkStatusEnums.CHECKED_SOME && this.disabled,
      };
    },
    handleClick() {
      if (this.disabled) return;
      let value = this.checkStatusEnums.CHECKED;
      if (this.checkState === this.checkStatusEnums.CHECKED) {
        value = this.checkStatusEnums.UNCHECK;
      }
      this.$emit('on-click', value);
    },
  },
};
</script>
<style lang="scss" scoped>
.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #111b49;
  cursor: pointer;
  &-disabled {
    cursor: none;
  }
  .checkbox-box {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    &--uncheck {
      background-color: #ffffff;
      border: 1px solid #c0c3d1;
      &-disabled {
        border: 1px solid #e7e8ee;
      }
    }
    &--checked {
      background-color: #4848ff;
      .bx-check {
        color: #ffffff;
      }
      &-disabled {
        background-color: #a8a9ff;
      }
    }
    &--checked-some {
      background-color: #ffffff;
      border: 1px solid #4848ff;
      .bx-minus {
        color: #4848ff;
      }
      &-disabled {
        border: 1px solid #a8a9ff;
        .bx-minus {
          color: #a8a9ff;
        }
      }
    }
  }
}
</style>
